(function () {
    'use strict';

    angular.module('sempraWebapp').controller('MoneyChangerJournalController', MoneyChangerJournalController);

    /** @ngInject */
    function MoneyChangerJournalController(moneyChangerJournalActions, organizationActions, $translate) {
        var vm = this;

        // DEFAULT DATE
        var currentYear = new Date().getFullYear();
        vm.dateFrom = new Date(currentYear, 0, 1, 0, 0, 0, 0);
        vm.dateTo = new Date();

        // FILTERS
        vm.sites = [];
        vm.selectedSite = null;
        vm.changers = [];
        vm.selectedChanger = null;

        // GRID CONFIG
        vm.orderBy = 'timestamp';
        vm.order = 'desc';
        vm.page = 1;
        vm.total = 0;
        vm.pageSize = 20;
        vm.pageOptions = [10, 20, 50];
        vm.entries = [];
        vm.pagerTranslations = {
            page: $translate.instant('GRID_PAGER_PAGE'),
            rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
            of: $translate.instant('GRID_PAGER_PAGE_OF')
        };

        init();

        function init() {
            loadSites();
            loadChangers();
            refreshData();
        }

        vm.sortChanged = function (order) {
            var orderQuery = getOrderObject(order);
            vm.orderBy = orderQuery.orderBy;
            vm.order = orderQuery.order;
            refreshData();
        };

        vm.pageChanged = function (page, limit) {
            vm.page = page;
            vm.pageSize = limit;
            refreshData();
        };

        vm.search = function () {
            vm.page = 1;
            refreshData();
        };

        vm.onSiteChange = function () {
            vm.selectedChanger = null;
            loadChangers();
            vm.search();
        };

        vm.onChangerChange = function () {
            vm.search();
        };

        vm.clearFilters = function () {
            vm.selectedSite = null;
            vm.selectedChanger = null;
            var currentYear = new Date().getFullYear();
            vm.dateFrom = new Date(currentYear, 0, 1, 0, 0, 0, 0);
            vm.dateTo = new Date();
            loadChangers();
            vm.search();
        };

        function loadSites() {
            organizationActions.getAllSitesForExactUser().then(function (data) {
                vm.sites = data || [];
            });
        }

        function loadChangers() {
            var siteId = vm.selectedSite ? vm.selectedSite.id : null;
            moneyChangerJournalActions.getChangers(siteId).then(function (data) {
                vm.changers = data || [];
            });
        }

        function refreshData() {
            var siteId = vm.selectedSite ? vm.selectedSite.id : null;
            var deviceKey = vm.selectedChanger ? vm.selectedChanger.deviceKey : null;

            vm.promise = moneyChangerJournalActions.getJournalEntries(
                siteId,
                null,
                deviceKey,
                vm.dateFrom.getTime(),
                vm.dateTo.getTime(),
                vm.page - 1,
                vm.pageSize,
                vm.orderBy,
                vm.order
            ).then(function (data) {
                vm.entries = data.content || [];
                vm.total = data.totalElements || 0;
                if (vm.entries.length === 0) {
                    vm.entries = [{ isEmpty: true }];
                }
            });
        }

        function getOrderObject(order) {
            var result = {
                order: 'asc',
                orderBy: order
            };

            if (order.indexOf('-') > -1) {
                result.order = 'desc';
                result.orderBy = order.substring(1);
            }
            return result;
        }
    }
})();
